var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "gallery-items"
  }, [_vm._l(_vm.notices, function (board) {
    return _c('div', {
      key: board.index,
      staticClass: "gallery-item",
      on: {
        "click": function ($event) {
          return _vm.showBoard(board);
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('div', {
      staticClass: "gallery-item__inner"
    }, [_c('div', {
      staticClass: "gallery-item__img",
      style: `background-image:url(${board.thumb});`
    }), _c('div', {
      staticClass: "gallery-item__con"
    }, [_c('h2', {
      staticClass: "gallery-item__tit"
    }, [_vm._v(_vm._s(board.subject))])])])])]);
  }), _vm._l(_vm.boards, function (board) {
    return _c('div', {
      key: board.index,
      staticClass: "gallery-item",
      on: {
        "click": function ($event) {
          return _vm.showBoard(board);
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('div', {
      staticClass: "gallery-item__inner"
    }, [_c('div', {
      staticClass: "gallery-item__img",
      style: `background-image:url(${board.thumb});`
    }), _c('div', {
      staticClass: "gallery-item__con"
    }, [_c('h2', {
      staticClass: "gallery-item__tit"
    }, [_vm._v(_vm._s(board.subject))])])])])]);
  })], 2), _c('div', {
    staticClass: "board-bottom"
  }, [_c('pagination-component', {
    attrs: {
      "count": _vm.count,
      "value": _vm.page
    },
    on: {
      "change": _vm.changePage
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }